import styled from 'styled-components';

interface ItemProps {
  readonly theme?: string;
  readonly inset?: string;
  readonly visible?: boolean;
}
export const ToolTipContainer = styled.div<ItemProps>`
  z-index: 998;
  position: fixed;
  background-color: rgba(62,70,78,0.75);
  border-radius: 4px;
  width: 160px;
  color: white;
  height: fit-content;
  display: none;
  text-align: center;
  inset: ${props => props.inset? props.inset: '0'};
`;
